var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.1313H14C9.02943 12.1313 5 16.0978 5 20.9907V34.0688C5 35.9328 6.51104 37.4438 8.375 37.4438H25M16 12.1313H32C32.338 12.1313 32.6716 12.1497 33 12.1854M16 12.1313C20.9706 12.1313 25 16.0978 25 20.9907V37.4438M25 37.4438H37.625C39.4889 37.4438 41 35.9328 41 34.0688V20.9907C41 16.4306 37.4999 12.6751 33 12.1854M33 25.9126V12.1854M33 12.1854V11.147C33 9.51601 34.3431 8.19385 36 8.19385H37.5M11 32.522H18.3024",
    stroke: "currentColor",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail2);
export default __webpack_public_path__ + "static/media/mail2.f63902c4e9a7ffe1b589037639782864.svg";
export { ForwardRef as ReactComponent };